<template>
  <page-banner :pageNumber="4" pageName="home" />
  <div class="mainContainer corporateCulture" id="video">
    <div class="container">
      <div class="ideaItem">
        <div class="title">
          <img src="../../assets/images/pages/qiyewenhua/vision2.png" />
          <div>企业愿景</div>
        </div>
        <div class="ideaContent">
          <div>传承文明 &nbsp;&nbsp;成就梦想</div>
          <div>续写建筑文明史 &nbsp;&nbsp;成就路桥中国梦 </div>
        </div>
      </div>
      <div class="ideaItem">
        <div class="title">
          <img src="../../assets/images/pages/qiyewenhua/idea1.png" />
          <div>发展理念</div>
        </div>
        <div class="ideaContent">
          <div>开放 &nbsp; 合作 &nbsp; 创新 &nbsp; 分享</div>
        </div>
      </div>
      <div class="ideaItem">
        <div class="title">
          <img src="../../assets/images/pages/qiyewenhua/idea2.png" />
          <div>开发理念</div>
        </div>
        <div class="ideaContent">
          <div>拓展 &nbsp; 责任 &nbsp; 精准 &nbsp; 提升</div>
        </div>
      </div>
      <div class="ideaItem">
        <div class="title">
          <img src="../../assets/images/pages/qiyewenhua/idea3.png" />
          <div>工作理念</div>
        </div>
        <div class="ideaContent">
          <div>专业 &nbsp; 责任 &nbsp; 规范 &nbsp; 提升</div>
        </div>
      </div>
    </div>
    <video muted :src="src" autoplay controls v-show="src" controlslist="nodownload noremoteplayback noplaybackrate"
           disablePictureInPicture="true" disableRemotePlayback="true"></video>
  </div>
  <div class="pageFooter">
    <div class="masks">
      <div class="leftMask"></div>
      <div class="rightMask"></div>
    </div>
    <div class="mainContainer footerContainer">
      <div class="block">
        <div class="head">
          <div class="zhTitle">责任</div>
          <div class="enTitle">responsibility</div>
        </div>
        <div class="content">责任是郑州路桥怀抱的初心<br />
          责任是郑州路桥砥砺奋进的动力</div>
      </div>
      <div class="block" style="margin-left: 20%">
        <div class="head">
          <div class="zhTitle">发展目标</div>
          <div class="enTitle">Development objectives</div>
        </div>
        <div class="content" style="width: 700px;">成为基础设施全产业链服务商、城市化进程服务体系建设者、数字经济和新基建开发运营商、区域资本运营主力军。</div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import {getVideo} from "../../apis";

  const src = ref("")
  getVideo().then(res => {
    src.value = import.meta.env.VITE_FILE_HOST + res.data.contentVideo
  })
  useHead({
    title: `企业文化 - 郑州路桥建设投资集团有限公司`
  })
</script>

<style scoped lang="scss">
  .corporateCulture {
    display: flex;
    margin-top: 80px;
    background: rgba(166, 208, 233, 0.1);
    justify-content: space-between;
    > .container {
      margin-right: 10px;
      margin-left: 10px;
      .ideaItem {
        display: flex;
        flex-direction: column;
        margin-bottom: 50px;
        .title {
          font-size: 28px;
          line-height: 50px;
          color: #163F5D;
          display: flex;
          align-items: center;
          > img {
            width: 60px;
            height: 60px;
            margin-right: 9px;
          }
        }
        .ideaContent {
          font-size: 20px;
          line-height: 26px;
          color: #000000;
          margin-left: 70px;
          > div {
            margin-bottom: 10px;
          }
        }
        &:first-child {
          .title {
            padding-top: 62px;
          }
        }
      }
    }
    > video {
      //width: 920px;
      width: 843px;
      //height: 790px;
      height: 532px;
      margin-top: 88px;
      background-color: #000000;
    }
  }
  .pageFooter {
    //width: 100%;
    min-width: var(--body-min-width);
    height: 522px;
    background: url("../../assets/images/pages/qiyewenhua/footerBg.png") no-repeat center;
    background-size: 100% 100%;
    margin: 144px 0 1px;
    position: relative;

    .masks {
      height: 522px;
      display: flex;
      flex-direction: row;
      align-items: center;

      .leftMask {
        height: 100%;
        width: 36%;
        background: rgba(255, 255, 255, 0.9);
      }

      .rightMask {
        height: 100%;
        width: 64%;
        background: rgba(255, 255, 255, 0.65);
      }
    }

    .footerContainer {
      position: absolute;
      left: 45%;
      top: 0;
      transform: translateX(-50%);
      //height: 100%;
      padding-top: 100px;
      padding-left: 20px;
      display: flex;
      align-items: center;

      >.block {
        flex-shrink: 0;

        >.head {
          margin-bottom: 85px;

          .zhTitle {
            font-size: 36px;
            line-height: 1.3;
            color: #163F5D;
          }

          .enTitle {
            font-size: 24px;
            line-height: 1;
            //line-height: 50px;
            color: #808695;
          }
        }

        >.content {
          font-size: 20px;
          line-height: 36px;
          text-align: justify;
          /* 浏览器可能不支持 */
          color: #333333;
          //width: 800px;
        }
      }
    }
  }
  @media (max-width: 1600px) {
    .pageFooter {
      .footerContainer {
        left: 50%;
      }
    }
  }
</style>